import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./PhoneInput.scss";

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
  error?: boolean;
  placeholder?: string;
  greenDisable?: boolean;
}

export default function PhoneInput({
  value,
  onChange,
  onBlur,
  disabled,
  error,
  placeholder = "(207) 555-0000",
  greenDisable,
}: PhoneInputProps) {
  const containerClass = [
    "csc-phone-input",
    error ? "input-error" : "",
    greenDisable ? "green-disable" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <ReactPhoneInput
      country="us"
      value={value.startsWith("+") ? value.slice(1) : value}
      onChange={(phone) => onChange("+" + phone)}
      onBlur={onBlur}
      disabled={disabled}
      placeholder={placeholder}
      containerClass={containerClass}
      inputClass="csc-phone-field"
      buttonClass="csc-phone-flag"
      countryCodeEditable={false}
    />
  );
}
